import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IgnoreDirtyDirective } from './ignore-dirty.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [IgnoreDirtyDirective],
  exports: [IgnoreDirtyDirective],
})
export class IgnoreDirtyModule {}
